export interface AdminReflectionInterface {
  id: number
  /**
   * 用户名
   */
  name: string
  /**
   * 账户
   */
  account: string
  /**
   * 用户所属学校 id
   */
  schoolId: number
  /**
   * 手机号
   */
  phone?: string | null
}

export class AdminReflection implements AdminReflectionInterface {
  id: number
  /**
   * 用户名
   */
  name: string
  /**
   * 账户
   */
  account: string
  /**
   * 用户所属学校 id
   */
  schoolId: number
  /**
   * 手机号
   */
  phone?: string | null

  constructor(props: AdminReflectionInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      id: _id,
      name: _name,
      account: _account,
      schoolId: _schoolId,
      phone: _phone,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.id = _id
    this.name = _name
    this.account = _account
    this.schoolId = _schoolId
    this.phone = _phone
  }
}
